import { readPendingStartInvite } from "./startInviteSession";

export const START_RESUME_PATH = "/start";

export function getStartResumePath(defaultPath: string): string {
  return readPendingStartInvite() ? START_RESUME_PATH : defaultPath;
}
